import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../base-types";
import { EntityResource } from "../entity-resource";
import { IEntityResourceContainer } from "../resource-containers/entity-resource-container";

@JsonObject()
export class GroupItem implements IEntityResourceContainer {
    @JsonProperty("row_id")
    rowId: Nullable<number> = null;

    @JsonProperty("column_id")
    columnId: Nullable<number> = null;

    @JsonProperty("number_of_results")
    numberOfResults: number;

    @JsonProperty("items")
    @JsonElementType(EntityResource)
    items: Array<EntityResource>;

    getEntityResources(): Array<EntityResource> {
        return this.items;
    }
}
